import React, { useContext } from 'react'
import { ModelContext } from '@abroad/components'

const ScheduleCallButton = ({ className, children }) => {
  const { onShow } = useContext(ModelContext)

  return (
    <a onClick={onShow} className={className}>
      {children}
    </a>
  )
}

export default ScheduleCallButton
